// @ts-check
import { forEach } from "lodash";

import setLineItemWithForecastCells from "./setLineItemWithForecastCells";

const setGroupingsWithForecastCells = ({
  groupings,
  macroAllocations,
  columns,
  groupedByDemand,
  rootGroup,
}) => {
  forEach(groupings, (grouping) => {
    const macroAllocationsForGrouping = macroAllocations[grouping.groupId];
    forEach(grouping.lineItems, (lineItem) => {
      setLineItemWithForecastCells({
        lineItem,
        macroAllocations: macroAllocationsForGrouping?.[lineItem.groupId],
        columns,
        rootGroup,
      });
    });

    setGroupingsWithForecastCells({
      groupings: grouping.childGroupings,
      macroAllocations,
      columns,
      groupedByDemand,
      rootGroup,
    });
  });
};

export default setGroupingsWithForecastCells;
